"use client";

import React from "react";
import { siteConfig } from "@/config/site.config";

export const PorQueCoplestonSection: React.FC = () => {
  return (
    <section className="relative py-20 md:py-24 px-6 md:px-12 bg-bg-secondary/30 border-y border-gold/15 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.04),transparent_75%)] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10 text-center flex flex-col items-center">
        <span className="text-[10px] md:text-xs font-semibold tracking-[0.4em] text-gold uppercase mb-4">
          Tradición y Método
        </span>

        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl text-text-pure tracking-wide font-light mb-6">
          {siteConfig.porQueCopleston.titulo}
        </h2>

        <div className="w-12 h-[1px] bg-gold/50 mb-8" />

        <p className="text-text-pure/85 text-base md:text-lg font-light leading-relaxed tracking-wide max-w-3xl">
          {siteConfig.porQueCopleston.texto}
        </p>

        <div className="flex items-center gap-3 mt-8 opacity-60">
          <span className="w-8 h-[1px] bg-gold" />
          <span className="text-[10px] font-sans tracking-[0.3em] uppercase text-text-muted">
            {siteConfig.lema} · {siteConfig.ubicacion}
          </span>
          <span className="w-8 h-[1px] bg-gold" />
        </div>
      </div>
    </section>
  );
};
